import { render } from "./FlagLibrary.vue?vue&type=template&id=ff6f254c&scoped=true"
import script from "./FlagLibrary.vue?vue&type=script&lang=js"
export * from "./FlagLibrary.vue?vue&type=script&lang=js"

import "./FlagLibrary.vue?vue&type=style&index=0&id=ff6f254c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6f254c"]])

export default __exports__